import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../lib/cart";

export const Navbar = () => {
  const { items } = useCart();
  const loc = useLocation();
  const links = [
    { to: "/", label: "All" },
    { to: "/c/ebooks", label: "E-Books" },
    { to: "/c/templates", label: "Templates" },
    { to: "/c/courses", label: "Courses" },
    { to: "/c/bundles", label: "Bundles" },
  ];
  return (
    <header className="sticky top-0 z-40 backdrop-blur-2xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <img src="/logo-ddl.png" alt="Digital Dime Lab" className="w-7 h-7 group-hover:scale-110 transition-transform duration-300" />
          <span className="font-head text-lg tracking-tight font-semibold">DIGITAL DIME<span className="text-zinc-500"> LAB</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "")}`}
              className={`text-sm tracking-wide transition-colors duration-200 ${
                loc.pathname === l.to ? "text-white" : "text-zinc-400 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <Link
          to="/cart"
          data-testid="cart-link"
          className="relative flex items-center gap-2 px-4 py-2 rounded-md border border-white/15 hover:border-white/40 transition-colors duration-200"
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="text-sm">Cart</span>
          {items.length > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -top-2 -right-2 bg-white text-black text-[11px] font-bold w-5 h-5 rounded-full flex items-center justify-center"
            >
              {items.length}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
};
